import {AbstractDTO} from '../abstract';
import {Block} from './block';

export class Template extends AbstractDTO {
    price: number = 0;
    isPoa: boolean = false;
    blocks: any[] = [];
	templateVar: string;
    priceDecimalPoints: number;
    priceFormat: string;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes ? attributes : {};
        Object.assign(this, attributes);
        this.blocks = Block.createFromArray(attributes['blocks']) || [];
        this.templateVar = attributes['templateVar'];
        this.priceDecimalPoints = attributes['priceDecimalPoints'] || 0;
        this.priceFormat = '1.' + this.priceDecimalPoints + '-' + this.priceDecimalPoints;
    }

}
